import type { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { legacyClientPortalPath } from "./routes";

/** `/client` links in old emails and bookmarks land on the new portal. */
export const LegacyClientPortalRedirect: FC = () => {
  const { search } = useLocation();
  return <Navigate to={legacyClientPortalPath(search)} replace />;
};
